import { useState } from 'react'

import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { IntentionForm, type TIntentionFormProps } from '@/src/features/intention/ui/components/IntentionForm'

export const useIntentionForm = (intentionFormProps: TIntentionFormProps = {}) => {
  const [hadIntention, setHadIntention] = useState<boolean | undefined>()
  const { isPending, data: me } = useMeQuery()

  const hasIntention = !!me?.intention

  if (!isPending && hadIntention === undefined) {
    setHadIntention(hasIntention)
  }

  return hadIntention ? null : <IntentionForm {...intentionFormProps} />
}
